module.exports = __webpack_public_path__ + "fonts/GothamRounded-Bold.f832b99b.woff";